import React from "react";
import PhotoBoothButton from "./PhotoBoothButton";
import SelfieButton from "./SelfieButton";
import { Say } from "../../../languages";

type Props = {
  visible: boolean;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  photoType: string;
  handlePhotoBoothClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PhotoTypeSelect = ({
  photoType,
  visible,
  handleFileChange,
  handlePhotoBoothClick
}: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="photo-moderation__button-wrapper">
      <PhotoBoothButton
        visible={["all", "booth"].includes(photoType)}
        handlePhotoBoothClick={handlePhotoBoothClick}
      />

      {photoType === "all" ? (
        <div className="photo-moderation__button-seperator">
          <Say phrase="photo_step.or" />
        </div>
      ) : null}

      <SelfieButton
        handleFileChange={handleFileChange}
        visible={photoType !== "booth"}
        classList={`${photoType === "selfie" ? "photo-moderation__selfie-button" : "photo-moderation__selfie-button--secondary"}`}
      />
    </div>
  );
};

export default PhotoTypeSelect;
